import { supabase } from '../supabase';

// Canonical reference-data lookups powering the State -> County -> School
// District cascade in AthleteForm (011). All four reference tables
// (states, counties, school_districts, school_district_counties) are
// database-backed — nothing here is hardcoded in the frontend, so a
// second state later is purely more reference rows, no code change.
//
// Unlike the free-text approach this replaced, these are STRICT
// controlled-vocabulary dropdowns: a guardian selects from what's
// returned here, they don't type an arbitrary value. See migration 011
// for the full Wisconsin sourcing methodology (DPI + NCES) and its
// documented data-quality decisions (e.g. the 2%-land-area materiality
// threshold on district/county relationships).

/** Active states, alphabetical by name. */
export async function listStates() {
  const { data, error } = await supabase
    .from('states')
    .select('code, name')
    .eq('active', true)
    .order('name');
  if (error) throw error;
  return data;
}

/** Active counties for a state, alphabetical. */
export async function listCountiesForState(stateCode) {
  if (!stateCode) return [];
  const { data, error } = await supabase
    .from('counties')
    .select('id, name')
    .eq('state_code', stateCode)
    .eq('active', true)
    .order('name');
  if (error) throw error;
  return data;
}

/** Active districts associated with a county, via the many-to-many
 * school_district_counties join — a district that spans multiple
 * counties is offered under each one it's linked to. */
export async function listDistrictsForCounty(countyId) {
  if (!countyId) return [];
  const { data, error } = await supabase
    .from('school_district_counties')
    .select('school_districts!inner(id, name, active)')
    .eq('county_id', countyId)
    .eq('school_districts.active', true);
  if (error) throw error;
  const districts = (data || []).map(r => r.school_districts);
  return districts.sort((a, b) => a.name.localeCompare(b.name));
}
